import { render } from "./set-sku-price.vue?vue&type=template&id=529bead4&scoped=true&ts=true"
import script from "./set-sku-price.vue?vue&type=script&lang=ts"
export * from "./set-sku-price.vue?vue&type=script&lang=ts"

import "./set-sku-price.vue?vue&type=style&index=0&id=529bead4&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-529bead4"]])

export default __exports__